import _regeneratorRuntime from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _slicedToArray from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { __awaiter } from "tslib";
import React, { useState, useRef } from 'react';
import { ConfirmationModal } from '@scp/ui-shared/components/modals';
export var HIPAA_TERMS_STATUS_KEY = 'hippaTermsAccepted';
var TEXT = {
  MODAL_TITLE: 'HIPAA compliance',
  ACCEPT: 'Accept',
  DECLINE: 'Decline'
};
export function withHipaaConfirm(_ref) {
  var _this = this;

  var confirmText = _ref.confirmText;
  return function (WrappedComponent) {
    return function (props) {
      var actionOnHoldRef = useRef(null);

      var _useState = useState(false),
          _useState2 = _slicedToArray(_useState, 2),
          modalOpen = _useState2[0],
          setModalOpen = _useState2[1];

      var checkHipaa = function checkHipaa(action) {
        return function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            var actionOnHold, isHipaaAccepted;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    actionOnHold = function actionOnHold() {
                      return action.apply(void 0, args);
                    };

                    isHipaaAccepted = JSON.parse(localStorage.getItem(HIPAA_TERMS_STATUS_KEY) || 'false');

                    if (isHipaaAccepted) {
                      _context.next = 6;
                      break;
                    }

                    setModalOpen(true);
                    actionOnHoldRef.current = actionOnHold;
                    return _context.abrupt("return");

                  case 6:
                    _context.next = 8;
                    return actionOnHold();

                  case 8:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
        };
      };

      var handleAccept = function handleAccept() {
        return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  localStorage.setItem(HIPAA_TERMS_STATUS_KEY, JSON.stringify(true));
                  setModalOpen(false);

                  if (!actionOnHoldRef.current) {
                    _context2.next = 6;
                    break;
                  }

                  _context2.next = 5;
                  return actionOnHoldRef.current();

                case 5:
                  actionOnHoldRef.current = null;

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
      };

      var handleDecline = function handleDecline() {
        setModalOpen(false);
        actionOnHoldRef.current = null;
      };

      return React.createElement(React.Fragment, null, React.createElement(WrappedComponent, Object.assign({}, props, {
        checkHipaa: checkHipaa
      })), React.createElement(ConfirmationModal, {
        noPaperPadding: true,
        narrow: true,
        open: modalOpen,
        title: TEXT.MODAL_TITLE,
        onAccept: handleAccept,
        onCancel: handleDecline,
        acceptLabel: TEXT.ACCEPT,
        cancelLabel: TEXT.DECLINE
      }, confirmText));
    };
  };
}